module.exports = __webpack_public_path__ + "/images/logo-hellobb-white.87c9d93.png";